// const gridConfig2 = {
//     background: 'transparent',
//     axis: {
//         color: '#666666',
//         width: 4,
//     },
//     scale: [
//         {
//             tickInterval: 1250,
//             tickColor: '#FFFFFF',
//             tickWidth: 4,
//             tickLength: 20,

//             labels: {
//                 step: 2,
//                 color: '#FFFFFF',
//                 font: 'Helvetica',
//                 fontSize: '20px'
//             }
//         }
//     ],

//     grid: [
//         {
//             color: 'orange',
//             interval: 25000,
//             width: 4,
//             length: 50
//         }
//     ]
// }

const base = 64;
const base2 = 5000;

export const gridConfig = {
  background: "transparent", //#333540',
  axis: {
    color: "#535560",
    width: 2,
  },
  scale: [
    {
        tickInterval: base * Math.pow(8, 8), // 25000
        tickColor: "#535560",
        tickWidth: 2,
        tickLength: 20,
      },
      {
        tickInterval: base * Math.pow(8, 7), // 25000
        tickColor: "#535560",
        tickWidth: 2,
        tickLength: 20,
      },
      {
        tickInterval: base * Math.pow(8, 6), // 25000
        tickColor: "#535560",
        tickWidth: 2,
        tickLength: 20,
      },

      {
      tickInterval: base * Math.pow(8, 5), // 25000
      tickColor: "#535560",
      tickWidth: 2,
      tickLength: 20,
    },
    {
      tickInterval: base * Math.pow(8, 4), // 25000
      tickColor: "#535560",
      tickWidth: 2,
      tickLength: 20,
    },
    {
      tickInterval: base * Math.pow(8, 3), // 25000
      tickColor: "#535560",
      tickWidth: 2,
      tickLength: 20,
    },
    {
      tickInterval: base * Math.pow(8, 2), // 2500
      tickColor: "#535560",
      tickWidth: 2,
      tickLength: 20,
    },
    {
      tickInterval: base * Math.pow(8, 1), // 250
      tickColor: "#535560",
      tickWidth: 2,
      tickLength: 20,
    },
  ],

  grid: [

    {
        color: "rgb(83,85,96, 1)",
        interval: base * Math.pow(2, 5), // 5000
        width: 4,
        length: 4,
        scaleLength: false,
      },
      {
        color: "rgb(83,85,96, 1)",
        interval: base * Math.pow(2, 4), // 5000
        width: 4,
        length: 4,
        scaleLength: false,
      },
      {
        color: "rgb(83,85,96, 1)",
        interval: base * Math.pow(2, 3), // 5000
        width: 4,
        length: 4,
        scaleLength: false,
      },


    {
      color: "rgb(83,85,96, 1)",
      interval: base * Math.pow(2, 2), // 5000
      width: 4,
      length: 4,
      scaleLength: false,
    },
    {
      color: "rgb(83,85,96, 1)",
      interval: base * Math.pow(2, 1), // 5000
      width: 4,
      length: 4,
      scaleLength: false,
    },
    {
      color: "rgb(83,85,96, 1)",
      interval: base * Math.pow(2, 0), // 5000
      width: 4,
      length: 4,
      scaleLength: false,
    },
    {
      color: "rgb(83,85,96, 1)",
      interval: base * Math.pow(2, -1), // 5000
      width: 4,
      length: 4,
      scaleLength: false,
    },
    {
      color: "rgb(83,85,96, 1)",
      interval: base * Math.pow(2, -2), // 500
      width: 4,
      length: 4,
      scaleLength: false,
    },
    {
      color: "rgb(83,85,96, 1)",
      interval: base * Math.pow(2, -3), // 50
      width: 4,
      length: 4,
      scaleLength: false,
    },
  ],

  mix: [
    {
        minZoom: 0, //0.125 /4,
        maxZoom: 0.125 / 2,
        fadeZoom: 0,
      },
      {
        minZoom: 0.125 / 2,
        maxZoom: 0.125,
        fadeZoom: 0,
      },
      {
        minZoom: 0.125,
        maxZoom: 0.25,
        fadeZoom: 0,
      },

    {
      minZoom: 0.25,
      maxZoom: 0.5,
      fadeZoom: 0,
    },
    {
      minZoom: 0.5,
      maxZoom: 1,
      fadeZoom: 0,
    },
    {
      minZoom: 1,
      maxZoom: 2,
      fadeZoom: 0,
    },
    {
      minZoom: 2,
      maxZoom: 4,
      fadeZoom: 0,
    },
    {
      minZoom: 4,
      maxZoom: 8,
      fadeZoom: 0,
    },
    {
      minZoom: 8,
      maxZoom: 16,
      fadeZoom: 0,
    },
  ],
};
export const gridConfig2 = {
  background: "#151515", //#333540',
  axis: {
    color: "#535560",
    width: 1,
  },
  scale: [
    {
      tickInterval: base2 * 5,
      tickColor: "#535560",
      tickWidth: 1,
      tickLength: 5,
    },
    {
      tickInterval: (base2 / 10) * 5,
      tickColor: "#535560",
      tickWidth: 1,
      tickLength: 5,
    },
    {
      tickInterval: (base2 / 10 / 10) * 5,
      tickColor: "#535560",
      tickWidth: 1,
      tickLength: 5,
    },
  ],

  grid: [
    {
      color: "rgb(83,85,96, 1)",
      interval: base2,
      width: 1,
      length: 5,
      scaleLength: false,
    },
    {
      color: "rgb(83,85,96, 1)",
      interval: base2 / 10,
      width: 1,
      length: 2,
      scaleLength: false,
    },
    {
      color: "rgb(83,85,96, 1)",
      interval: base2 / 10 / 10,
      width: 2,
      length: 2,
      scaleLength: false,
    },
  ],

  mix: [
    {
      minZoom: 0,
      maxZoom: 0.08,
      fadeZoom: 0.5,
    },
    {
      minZoom: 0.08,
      maxZoom: 0.5,
      fadeZoom: 0.5,
    },
    {
      minZoom: 0.5,
      maxZoom: 16,
      fadeZoom: 0.5,
    },
  ],
};

export default {
  gridConfig,
  gridConfig2,
};
